import { Box, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Overlay = styled('div')(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(0,0,0,0.5)',
  zIndex: 1300,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'opacity 200ms ease, transform 200ms cubic-bezier(0.4,0,0.2,1)',
}));

export const Container = styled(Box)(({ theme }) => ({
  background: '#fff',
  borderRadius: 8,
  maxWidth: 800,
  maxHeight: '90vh',
  width: '100%',
  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100vw',
    maxHeight: '100vh',
    borderRadius: 0,
  },
}));

export const Header = styled('header')(({ theme }) => ({
  background: '#fff',
  position: 'sticky',
  top: 0,
  zIndex: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '24px 32px 16px 32px',
  borderBottom: '1px solid #f0f0f0',
  minHeight: 72,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '16px 16px 8px 16px',
    minHeight: 56,
  },
}));

export const Title = styled(Typography)(() => ({
  fontSize: 24,
  fontWeight: 700,
  color: '#172b4d',
  flex: 1,
}));

export const Subtitle = styled(Typography)(() => ({
  fontSize: 14,
  color: '#6b778c',
  fontWeight: 400,
  marginLeft: 16,
  alignSelf: 'flex-end',
}));

export const CloseButton = styled(IconButton)(() => ({
  background: '#172b4d',
  color: '#fff',
  borderRadius: '50%',
  width: 36,
  height: 36,
  marginLeft: 16,
  '&:hover': {
    background: '#0d1a2b',
  },
  position: 'absolute',
  right: 24,
  top: 24,
}));

export const Body = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  minHeight: 0,
  height: '100%',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const Sidebar = styled('nav')(({ theme }) => ({
  width: 200,
  background: 'transparent',
  borderRight: '1px solid #f0f0f0',
  padding: '32px 0 32px 32px',
  overflowY: 'auto',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const SidebarList = styled('ul')(() => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
}));

export const SidebarItem = styled('li', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ active }) => ({
  padding: '10px 0 10px 12px',
  fontWeight: 500,
  fontSize: 15,
  color: active ? '#00bfa6' : '#172b4d',
  borderLeft: active ? '4px solid #00bfa6' : '4px solid transparent',
  background: active ? 'rgba(0,191,166,0.07)' : 'transparent',
  cursor: 'pointer',
  transition: 'background 0.2s, color 0.2s',
  marginBottom: 4,
}));

export const Content = styled('div')(({ theme }) => ({
  flex: 1,
  padding: '32px',
  overflowY: 'auto',
  maxHeight: 'calc(90vh - 72px)',
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
    maxHeight: 'unset',
  },
}));

export const SectionTitle = styled(Typography)(() => ({
  fontSize: 18,
  fontWeight: 700,
  color: '#172b4d',
  margin: '32px 0 8px 0',
}));

export const Paragraph = styled(Typography)(() => ({
  fontSize: 15,
  fontWeight: 400,
  color: '#172b4d',
  lineHeight: 1.5,
  marginBottom: 16,
}));

export const CollapsibleIndex = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('sm')]: {
    display: 'block',
    marginBottom: 16,
    button: {
      background: '#00bfa6',
      color: '#fff',
      border: 'none',
      borderRadius: 4,
      padding: '8px 16px',
      fontWeight: 600,
      fontSize: 15,
      cursor: 'pointer',
      marginBottom: 8,
    },
  },
}));
